import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IonicComponentsModule } from '@app/shared/modules/ionic-components/ionic-components.module';

export interface CardBoxOverviewCard {
  title: string;
  amount: string;
  approx: string;
  hint?: string;
  icon: string;
}

@Component({
  selector: 'app-card-box',
  standalone: true,
  imports: [CommonModule, IonicComponentsModule],
  templateUrl: './card-box.component.html',
})
export class CardBoxComponent {
  variant = input<'default' | 'overview'>('default');
  title = input<string>('');
  subtitle = input<string>('');
  assetImage = input<string>('');
  overviewCards = input<CardBoxOverviewCard[]>([]);
}
